export const replaceAll = (str: string, find: string, replace: string): string => {
  const escapeRegExp = (innerStr: string) => innerStr.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
};
